<html>
<head>
</head>
<body>
    <form method="post">

        <div>
            <div>

                <h3>Hello, Venu gopal. <!-- 140425 or vpandadual -->  Plan Year is 2018</h3>

                <fieldset id="fsAboutApplicant-fieldset" class="form-input-buttonlist ">

                    <h5>Confirm the Enrollment Details Below</h5>

                    <h6>Please review the following information, and click the button at the bottom of the page to submit the application for your client, or click to go back and edit details.</h6>

                    <h4>Please note that your enrollment has not yet been submitted. Please review the data and click the submit button at the bottom of the page to complete the enrollment.</h4>

                    <div id="table">
                        <table id="MainContent_tbDetails" style="width:90%;">
                            <caption>Enrollment details</caption>
                            <tr>
                                <td class="name"><strong>Agent ID</strong></td>
                                <td class="value">vpandadual</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Data Entry ID</strong></td>
                                <td class="value">vpandadual</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Title</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>First Name</strong></td>
                                <td class="value">mike</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Middle Initial</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Last Name</strong></td>
                                <td class="value">watts</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Medicare Number</strong></td>
                                <td class="value">123456789a</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Application Date</strong></td>
                                <td class="value">12/5/2017</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Effective Date</strong></td>
                                <td class="value">1/1/2018</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Applicant State</strong></td>
                                <td class="value">MI</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Selected Plan</strong></td>
                                <td class="value">SilverScript Choice</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>CUID</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Election Period</strong></td>
                                <td class="value">OpenEnrollment</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Enrollment Criteria</strong></td>
                                <td class="value">-</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Enrollment Type</strong></td>
                                <td class="value">EDIP</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Phone Number</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Date of Birth</strong></td>
                                <td class="value">11/10/1950</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Gender</strong></td>
                                <td class="value">male</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Email</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Permanent Address 1</strong></td>
                                <td class="value">230 Harvard Rd</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Permanent Address 2</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Permanent City</strong></td>
                                <td class="value">Detroit</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Permanent State</strong></td>
                                <td class="value">MI</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Permanent Zip</strong></td>
                                <td class="value">48127</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Mailing Address 1</strong></td>
                                <td class="value">230 Harvard Rd</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Mailing Address 2</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Mailing City</strong></td>
                                <td class="value">Detroit</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Mailing State</strong></td>
                                <td class="value">MI</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Mailing Zip</strong></td>
                                <td class="value">48127</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Long-term Care Name</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Long-term Care Phone</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Medicare Part A Date</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Medicare Part B Date</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Premium Payment Type</strong></td>
                                <td class="value">Direct Bill</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Language Preference</strong></td>
                                <td class="value">english</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Receives Electronic Explanation of Benefits</strong></td>
                                <td class="value">No</td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Secondary Coverage Name</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Secondary Coverage ID</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Secondary Coverage Group</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Authorized Representative Name</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Authorized Representative Phone</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Authorized Representative Relationship</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Authorized Representative Address</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Authorized Representative City</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Authorized Representative State</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Authorized Representative Zip</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Name on Account</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Account Type</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Routing Number</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Financial Institution</strong></td>
                                <td class="value"></td>
                            </tr>
                            <tr>
                                <td class="name"><strong>Account Number</strong></td>
                                <td class="value"></td>
                            </tr>
                        </table>
                    </div>



                    <table class="noteArea" cellpadding="2px" cellspacing="5px">
                        <tr>

                            <td>


                                <div id="btnAgreed-div" class="form-button-submit even">
                                    <span><input name="ctl00$MainContent$btnAgreed" type="submit" id="MainContent_btnAgreed" value="Submit My Client&#39;s Applications" class="composeButton3" /></span>
                                </div>



                            </td>

                            <td>


                                <div id="hlBack-div" class="form-button-submit even last">
                                    <span><input name="ctl00$MainContent$hlBack" type="submit" id="MainContent_hlBack" value="Go Back" class="composeButton3" /></span>
                                </div>



                            </td>

                        </tr>
                    </table>

                </fieldset>


            </div>
        </div><!-- content -->
        <div id="footer">

            <a id="footerMenu_lbAgentNewApplication" href="/enroll/agent/default.aspx">Start New Application</a>&nbsp;&nbsp;|&nbsp;&nbsp;
            <a id="footerMenu_lbHome" href="/enroll/choose2013.aspx">Home</a>

        </div>
       
    </form>
</body>
</html>

